<template>
  <div class="home-pannel concented" style="height: 100%;">
    <div class="home-pannel-title titleed">
      <span>付款数据统计</span>
      <div class="titleed-sele" style="margin-left: 10px;">
        <queryView @select="timeSelect" />
      </div>
      <a-tooltip>
        <template slot="title">
          切换
        </template>
        <a-button type="primary" shape="circle" class="changeIcon" @click="changeTanOrChart">
          <a-icon type="swap" style="fontSize:18px;paddingTop:4px;"/>
        </a-button>
      </a-tooltip>
    </div>
    <div style="height: 86%;">
      <div v-show="showValue === 'chart'" style="height:100%;">
        <div ref="paymentPlanChart" style="width: 96%;height: 96%;"/>
      </div>
      <div  v-show="showValue === 'table'">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :loading="tableLoadding"
          :pagination="tablePagination"
          :rowKey="(record,index)=>{return index}"
          :scroll="{ y: 240 }"
          size="small"
          style="width:100%;padding:6px;"
          @change="pageChange"
          bordered
        >
          <template slot="subjectSlot" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                {{ record.subject }}
              </template>
              <span class="onClickStyle" @click="viewClick(record, 'subject')">{{ record.subject }}</span>
            </a-tooltip>
          </template>
          <template slot="purchaseSlot" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                {{ record.purchaseName }}
              </template>
              <span class="onClickStyle" @click="viewClick(record, 'purchase')">{{ record.purchaseName }}</span>
            </a-tooltip>
          </template>
          <template slot="jineSlot" slot-scope="text">
            <span>￥{{ parseFloat(text).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
          </template>
        </a-table>
      </div>
    </div>
    <click-view
      ref="clickViewRef"
      :dialog-visible="clickViewVisible"
      @close="clickViewClose"
    />
  </div>
</template>

<script>
import queryView from '../queryView.vue'
import clickView from '@/components/view/clickView.vue'
export default {
  components: { queryView, clickView },
  data () {
    return {
      clickViewVisible: false,
      paymentPlanChart: null,
      countsed: 0,
      showValue: 'chart',
      tableLoadding: false,
      tablePagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizeOptions: [ '5', '10', '15', '20' ],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      tableData: [],
      columns: [
        {
          width: 110,
          title: '项目名称',
          dataIndex: 'subject',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'subjectSlot' }
        },
        {
          width: 110,
          title: '采购单',
          dataIndex: 'purchaseName',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'purchaseSlot' }
        },
        {
          width: 74,
          title: '采购单金额(元)',
          dataIndex: 'totalPrice',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 66,
          title: '应付金额(元)',
          dataIndex: 'planMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 66,
          title: '实付金额(元)',
          dataIndex: 'payMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        }
      ],
      timeQueryVal: 1
    }
  },
  mounted () {
    this.initEcharts()
    this.initTableData()
  },
  methods: {
    timeSelect (timeVal) {
      this.tablePagination.current = 1
      this.tablePagination.pageNum = 1
      this.tablePagination.pageSize = 10
      this.timeQueryVal = timeVal
      this.initEcharts()
      this.initTableData()
    },
    initEcharts () {
      setTimeout(() => {
        this.paymentPlanChart = this.$echarts.init(this.$refs.paymentPlanChart)
        this.setEcharts()
      }, 200)
    },
    initTableData () {
      let pramsObj = {
        pageSize: this.tablePagination.pageSize,
        pageNum: this.tablePagination.pageNum,
        timeCondition: this.timeQueryVal
      }
      this.$get('payPlan/planPage', pramsObj).then(res => {
        if (res.data.status === 1) {
          this.tableData = res.data.data.records
          this.tablePagination.total = res.data.data.total
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    viewClick (rowVal, val) {
      if (val === 'purchase') {
        if (rowVal.purchaseId) {
          this.clickViewVisible = true
          this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.purchaseId)
        }
      } else if (val === 'subject') {
        if (rowVal.projectId) {
          this.clickViewVisible = true
          this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
        }
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    },
    changeTanOrChart () {
      if (this.showValue === 'chart') {
        this.showValue = 'table'
      } else if (this.showValue === 'table') {
        this.showValue = 'chart'
        this.initEcharts()
      }
    },
    pageChange (pageVal) {
      this.tablePagination.current = pageVal.current
      this.tablePagination.pageNum = pageVal.current
      this.tablePagination.pageSize = pageVal.pageSize
      this.initTableData()
    },
    setEcharts () {
      this.countsed = 0
      this.$get('payPlan/count', {timeCondition: this.timeQueryVal}).then(res => {
        let arr = []
        res.data.data.forEach(item => {
          this.countsed += Number(item.sum)
          if (item.type === 0) {
            arr.push({
              name: '应付款',
              value: item.sum,
              value1: item.count,
              itemStyle: {color: '#f9ae3d'}
            })
          } else {
            arr.push({
              name: '实付款',
              value: item.sum,
              value1: item.count,
              itemStyle: {color: '#3c9cff'}
            })
          }
        })
        this.createpaymentPlanChart(arr)
      })
    },
    createpaymentPlanChart (arr) {
      let that = this
      let option = {
        backgroundColor: 'white',
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function (value) {
            return `金额 : ${value.data.value}元 <br/> 数量 : ${value.data.value1}笔`
          },
          backgroundColor: 'rgba(1, 13, 19, 0.5)',
          borderWidth: 0,
          textStyle: {
            color: 'rgba(212, 232, 254, 1)'
            // fontSize: fontChart(0.24),
          }
        },
        legend: {
          // orient: 'vertical',
          left: 'center',
          bottom: '6%',
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
          borderRadius: 4,
          textStyle: {
            color: '#000',
            fontFamily: 'Alibaba PuHuiTi',
            fontSize: 14,
            fontWeight: 400
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            center: ['50%', '50%'],
            data: arr,
            label: {
              normal: {
                formatter: function (parms) {
                  var str = ((parms.data.value * 100) / (that.countsed * 100) * 100).toFixed(2) + '%'
                  if (isNaN(((parms.data.value * 100) / (that.countsed * 100)).toFixed(4))) {
                    if (parms.data.name === '未付款') {
                      return '{green|' + parms.data.name + '：}\n{d|' + '0%}'
                    } else {
                      return '{green|' + parms.data.name + '：}\n{e|' + '0%}'
                    }
                  } else {
                    if (parms.data.name === '未付款') {
                      return '{green|' + parms.data.name + '：}\n{d|' + str + '}'
                    } else {
                      return '{green|' + parms.data.name + '：}\n{e|' + str + '}'
                    }
                  }
                },
                textStyle: {
                  fontSize: '16px',
                  textAlign: 'center'
                },
                rich: {
                  c: {
                    color: 'red',
                    fontSize: 20,
                    fontWeight: 'bold',
                    lineHeight: 5
                  },
                  b: {
                    fontSize: 15,
                    height: 40
                  },
                  d: {
                    color: '#f9ae3d',
                    fontSize: '20px',
                    fontWeight: 900
                  },
                  e: {
                    fontSize: '20px',
                    fontWeight: 900,
                    color: '#3c9cff'
                  }
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.paymentPlanChart.setOption(option, true)
    }
  }
}
</script>

<style lang="less" scoped>
  .titleed{
    display: flex;
    &-sele{
      font-weight: 500;
    }
  }
  .echarts {
    width: 100%;
    display: flex; /*设置为Flex容器*/
    justify-content: center; /*水平居中对齐*/
  }
    .panel {
      padding-bottom: 0.6rem;
      background-color: #fff;
      border: 1px solid transparent;
      border-radius: 10px;

      .panel-title {
        width: 100%;
        border-bottom: solid 1px #e9e9e9;
        line-height: 50px;
        padding-left: 15px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 30px;
          background-color: #0079fe;
          position: absolute;
          left: 0;
          top: 10px;
          border-radius: 4px;
        }

        span {
          &:first-child {
            font-size: 18px !important;
            font-weight: 400;
          }
        }
      }
    }
    .changeIcon{
      position:absolute;
      right: 20px;
      top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/second/paymentPlanBieChart.vue